import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import type { ProvidedTaxRefundMethod } from '@/features/jobs/info-gathering/supporting-item-input'

/**
 * Props for {@link BusinessRefundMethodInfoSupportingItemInput}.
 */
export type BusinessRefundMethodInfoSupportingItemInputProps =
  ModelProps<BusinessRefundMethodInfoSupportingItemInput> & {
    type: 'BusinessRefundMethodInfo'
  }

/**
 * Supporting item input for a business tax refund method.
 */
export class BusinessRefundMethodInfoSupportingItemInput extends Model<BusinessRefundMethodInfoSupportingItemInput> {
  /**
   * The provided tax refund method, if any.
   */
  @observable.struct accessor provided: ProvidedTaxRefundMethod | null = null
}
